module.exports = __webpack_public_path__ + "static/img/2.1de8ae8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/2.png
// module id = RWSp
// module chunks = 0